module.exports = __webpack_public_path__ + "img/logo_vdm.586d01c0.png";